namespace $.$$ {
	export class $shm_hitalama_map_page_dragger extends $.$shm_hitalama_map_page_dragger {
		
		left(): string {
			return this.x() + 'px'
		}
		top(): string {
			return this.y() + 'px'
		}

		@ $mol_mem
		x( next?: number ): number {
			const widget = this.widget()
			return widget
				? this.anchor_hor() == 'right'
					? widget.left()
					: widget.left()+widget.width()
				: 0
		}

		@ $mol_mem
		y( next?: number ): number {
			const widget = this.widget()
			return widget
				? this.anchor_vert() == 'top'
					? widget.top()
					: widget.top()+widget.height()
				: 0
		}

		@ $mol_mem
		zoom_for_dragger() {
			return this.$.$shm_hitalama_settings.dragger_keep_size()
				? this.Map_page().zoom() : 1
		}

		@ $mol_mem
		set_pos() {
			new $mol_wire_atom( 'set_dragger_pos', ()=> {
				const page = this.Map_page()
				$mol_state_time.now(100)
				if( page.some_transforming() ) return
				if( page.hovered_link() && page.Widget( page.hovered_link() ).widget().type() == 'iframe' ) return
				const selected_links = page.selected_links()

				const pointer_client_pos = page.Pane().pointer_client_pos()
				if( pointer_client_pos[0] === 0 && pointer_client_pos[1] === 0 ) return

				const [cursor_x,cursor_y] = page.pointer_pos()
				const [shift_x, shift_y] = page.shift()
				const zoom = page.zoom()

				const nearest = {
					x_dist: Infinity,
					y_dist: Infinity,
					widget: null as $shm_hitalama_map_widget_float | null,
					anchor_hor: 'right',
					anchor_vert: 'top',
				}

				const threshold = 60
				const outer_gap = 1

				page.widgets_view().map( view => view.Sub() as $shm_hitalama_map_widget_float ).forEach( widget => {
					if( widget.widget().locked() ) return
					if( selected_links.length > 1 && selected_links.some( link => link.str == widget.widget().link().str ) ) return

					const left = widget.left() * zoom + shift_x
					const top = widget.top() * zoom + shift_y
					const right = ( widget.left() + widget.width() ) * zoom + shift_x
					const bottom = ( widget.top() + widget.height() ) * zoom + shift_y

					const corners = [
						{
							test_x: left - outer_gap,
							test_y: top + outer_gap,
							anchor_hor: 'right',
							anchor_vert: 'top',
						},
						{
							test_x: right + outer_gap,
							test_y: top + outer_gap,
							anchor_hor: 'left',
							anchor_vert: 'top',
						},
						{
							test_x: left - outer_gap,
							test_y: bottom - outer_gap,
							anchor_hor: 'right',
							anchor_vert: 'bottom',
						},
						{
							test_x: right + outer_gap,
							test_y: bottom - outer_gap,
							anchor_hor: 'left',
							anchor_vert: 'bottom',
						},
					]

					corners.forEach( corner => {
						const x_dist = Math.abs( cursor_x - corner.test_x )
						if( x_dist > threshold ) return

						const y_dist = Math.abs( cursor_y - corner.test_y )
						if( y_dist > threshold ) return

						if( x_dist ** 2 + y_dist ** 2 < nearest.x_dist ** 2 + nearest.y_dist ** 2 ) {
							nearest.x_dist = x_dist
							nearest.y_dist = y_dist
							nearest.widget = widget
							nearest.anchor_hor = corner.anchor_hor
							nearest.anchor_vert = corner.anchor_vert
						}
					} )
				} )

				this.anchor_hor( nearest.anchor_hor )
				this.anchor_vert( nearest.anchor_vert )
				this.widget( nearest.widget )
			} ).fresh()
		}

		pointerdown( event?: PointerEvent ) {
			const widget = this.widget()
			if( !widget || !event ) return

			widget.drag_pointerdown( event )
		}
		
		event() {
			return {
				... super.event(),
				contextmenu: ( event: Event )=> event.preventDefault(),
			}
		}

	}
}
